import { get, post } from '@/request/request'

export default {
  menuList() {
    return get('/admin/auth/menu/list')
  },
  menuSave(params) {
    return post('/admin/auth/menu/save', params)
  },
  menuDelete(params) {
    return post('/admin/auth/menu/delete', params)
  },
  userList() {
    return get('/admin/auth/user/list')
  },
  userSave(params) {
    return post('/admin/auth/user/save', params)
  },
  userDelete(params) {
    return post('/admin/auth/user/delete', params)
  },
  roleList() {
    return get('/admin/auth/role/list')
  },
  roleSave(params) {
    return post('/admin/auth/role/save', params)
  },
  roleDelete(params) {
    return post('/admin/auth/role/delete', params)
  },
  permList() {
    return get('/admin/auth/perm/list')
  },
  permSave(params) {
    return post('/admin/auth/perm/save', params)
  },
  userBindEmployee(params) {
    return post('/admin/auth/user/bind/employee', params)
  },
  userUnbindEmployee(params) {
    return post('/admin/auth/user/unbind/employee', params)
  },
  userBindWechatQrcode(params) {
    return get('/admin/auth/user/bind/wechat/qrcode', params)
  },
  userBindWechat(params) {
    return post('/admin/auth/user/bind/wechat', params)
  },
  userUnbindWechat(params) {
    return post('/admin/auth/user/unbind/wechat', params)
  }
}
